import React from 'react'
import type { RouteObject } from 'react-router-dom'
import ClientHome from 'spa/client/pages/ClientHome'
import ClientStaffPassword from 'spa/client/pages/ClientStaffPassword'
import ClientLogin from 'spa/client/pages/ClientLogin'
import ClientSignup from 'spa/client/pages/ClientSignup'
import ClientQuestionnaires from 'spa/client/pages/ClientQuestionnaires'
import ErrorPage from 'spa/client/pages/ErrorPage'
import ClientContractExtensionRequests from 'spa/client/pages/ClientContractExtensionRequests'
import ClientContractExtensionRequestsSubmitted from 'spa/client/pages/ClientContractExtensionRequestsSubmitted'
import ClientMonthlyWorkReports from '../../client/pages/ClientMonthlyWorkReports'
import ClientMonthlyWorkReportDetail from '../../client/pages/ClientMonthlyWorkReportDetail'

const ClientPath: RouteObject[] = [
  // NOTE: クライアントマイページのルーティング
  { path: '/client_auth/signup', element: <ClientSignup /> },
  { path: '/client_auth/:accessToken/password', element: <ClientStaffPassword /> },
  { path: '/client_auth/login', element: <ClientLogin /> },
  { path: '/clients/home', element: <ClientHome /> },
  { path: '/clients/questionnaires', element: <ClientQuestionnaires /> },
  { path: '/clients/monthly_work_reports', element: <ClientMonthlyWorkReports /> },
  { path: '/clients/monthly_work_reports/:monthlyWorkReportId', element: <ClientMonthlyWorkReportDetail /> },
  { path: '/clients/*', element: <ErrorPage /> },
  { path: '/client_auth/*', element: <ErrorPage /> },
  { path: '/clients/contract_extension_requests/:accessToken', element: <ClientContractExtensionRequests /> },
  { path: '/clients/contract_extension_requests/update', element: <ClientContractExtensionRequestsSubmitted /> }
]

export default ClientPath
